export enum FetchMethodEnum {
	get = 'GET',
	post = 'POST',
	put = 'PUT',
	delete = 'DELETE'
}

export enum FetchResponseType {
	json = 'json',
	blob = 'blob',
	response = 'response'
}